module.exports = __webpack_public_path__ + "media/images/iconEdit__okGreen--dark-82047abfb5d5d762fb7e5f7ae6ec519b.png";